import { Box, Link, Typography } from "@mui/material";
import * as React from "react";
import {
  Datagrid,
  // Link,
  List,
  useRecordContext,
  useRefresh,
} from "react-admin"; // eslint-disable-line import/no-unresolved
import useNotify from "../unit/useNotify";

import { hmLightTheme } from "../themes/hmTheme";
import PostPagination from "../unit/PostPagination";

import { RaRecord } from "react-admin";
import ReportListNewAside from "../reports/ReportListNewAside";
import CustomLoading from "../unit/CustomLoading";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
import NoPermission from "../unit/NoPermission";

const CustomMonthReportField = ({ ...props }) => {
  const year = props?.year;
  const record = useRecordContext();
  if (!record) return null;
  const showTitle = year + "-" + record?.id;
  // return (
  //   <Link
  //     to={`/#/monthreportDetail/${showTitle}/show`}
  //     // to={"/monthreport/show?period=" + encodeURIComponent(linkkey)}
  //     underline="none"
  //   >
  //     {showTitle}
  //   </Link>
  // );
  //use navigate
  const navigateLink = `/monthreportDetail/${showTitle}/show`;
  //showTitle is xxxx-xx, 如果日期在未来，则不显示链接
  const currentDate = new Date();
  const reportDate = new Date(`${year}-${record?.id}-01`);
  if (reportDate > currentDate) {
    return <Typography sx={{ color: "#ccc" }}>{showTitle}</Typography>;
  }
  return (
    <Link href={navigateLink} underline="none" className="report-id">
      {showTitle}
    </Link>
  );
};

// const CustomMonthReportField = ({ ...props }) => {
//   const year = props?.year;
//   const record = useRecordContext();
//   if (!record) return null;
//   const month = record?.month;
//   const showTitle = year ? year + "-" + month : month;
//   const linkkey = year ? year + "-" + month : month;
//   return (
//     <Link
//       to={`/monthreport/${encodeURIComponent("2023-01")}/show`}
//       // to={"/monthreport/show?period=" + encodeURIComponent(linkkey)}
//       underline="none"
//     >
//       {showTitle}
//     </Link>
//   );
// };
// const CustomButtonShow = ({ ...props }) => {
//   const record = useRecordContext();
//   if (!record) return null;
//   return (
//     <Link to={`/monthreport/${record.id}/show`} underline="none">
//       More
//     </Link>
//   );
// };
const DailyReportList = () => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const refresh = useRefresh();
  const [selectedRecord, setSelectedRecord] = React.useState<RaRecord | null>(
    null
  );
  const [open, setOpen] = React.useState(false);
  const [currentTab, setCurrentTab] = React.useState("info");
  const [record, setRecord] = React.useState<{ total: number } | null>(null);
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_reports")) {
    return <NoPermission />;
  }
  const handleButtonClick = (record) => {
    setOpen(true);
    setSelectedRecord(record);
  };

  //生成一个数组，从2023年开始，到本年度
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = 2023; year <= currentYear; year++) {
    years.push(year);
  }
  return (
    <>
      <List
        actions={<></>}
        filters={[]}
        aside={<ReportListNewAside selected="monthreport" />}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
        sort={{ field: "created_at", order: "DESC" }}
        sx={{
          width: "100%",
          borderRadius: "0px",
          wordBreak: "break-word",
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        pagination={<PostPagination />}
        perPage={25}
      >
        <Datagrid
          optimized
          // rowClick={"show"}
          rowClick={false}
          size="small"
          id="table-daily-report"
          className="hm-list-datagrid"
          sx={{
            ".MuiTableCell-root": {
              padding: "6px",
            },
            ".RaDatagrid-headerCell:first-child": {
              borderTopLeftRadius: "0px",
            },
            ".RaDatagrid-headerCell:last-child": {
              borderTopRightRadius: "0px",
            },
            overflowY: "auto",
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" },
            },
            "& .Mui-active": {
              color: "gray",
            },
            "& .MuiTableSortLabel-root": {
              padding: "5px",
            },
            "& .RaDatagrid-headerCell": {
              color: "gray",
              fontSize: "1rem",
              backgroundColor: "#edf4fb",
              wordWrap: "break-word",
              padding: "12px",
            },
            "& .RaDatagrid-rowCell": {
              padding: "12px",
            },
            "& .MuiTableCell-paddingCheckbox": {
              display: "none",
            },
            "& .MuiTableCell-root.column-title": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
          }}
        >
          {/* Report ID#	Description	Covered Period (for flow reports) As of Date (for snapshots)	Created On	Times Downloaded	Last Downloaded	Downloaded By	Action */}
          {/* 
          <TextField
            source="id"
            label="Date"
            cellClassName="numericText"
            sortBy="id"
          /> */}
          {/* <CustomMonthReportField source="month" label="Months" /> */}
          {years.map((year) => (
            <CustomMonthReportField
              year={year.toString()}
              source="id"
              label={year.toString()}
              sortable={false}
            />
          ))}
          {/* <CustomButtonShow label="Action" /> */}
        </Datagrid>
        <CustomLoading />
      </List>
    </>
  );
};

export default DailyReportList;
